import { useCallback, useEffect, useRef } from "react";

import { useNavigate } from "react-router-dom";

import { LOGIN_MAIN_URL } from "@/constants/routes";
import useLoginStore from "@/store/loginStore";

const INACTIVITY_TIMEOUT = 30 * 60 * 1000; // 30분

const useInactivityLogout = () => {
  const navigate = useNavigate();
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const { spotOnToken, logout } = useLoginStore();

  const handleLogout = useCallback(() => {
    logout();
    navigate(LOGIN_MAIN_URL);
  }, [logout, navigate]);

  const resetTimer = useCallback(() => {
    if (!spotOnToken) return;

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(handleLogout, INACTIVITY_TIMEOUT);
  }, [spotOnToken, handleLogout]);

  useEffect(() => {
    if (!spotOnToken) return;

    const events = ["mousedown", "keydown", "touchstart", "scroll"] as const;

    events.forEach(event => window.addEventListener(event, resetTimer));
    resetTimer(); // 초기 타이머 시작

    return () => {
      events.forEach(event => window.removeEventListener(event, resetTimer));
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [spotOnToken, resetTimer]);
};

export default useInactivityLogout;
